var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeftCircle = function SvgArrowLeftCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "arrow-left-circle_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4.496a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-10 8c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27 13.246a.76.76 0 0 1-.77-.75.76.76 0 0 1 .77-.75h6.604l-.995-.97a.737.737 0 0 1 0-1.06.783.783 0 0 1 1.088 0l2.308 2.25c.3.292.3.767 0 1.06l-2.308 2.25a.783.783 0 0 1-1.088 0 .737.737 0 0 1 0-1.06l.995-.97H7.269z",
    fill: "currentColor"
  })));
};

export { SvgArrowLeftCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjUgNC40OTZhOCA4IDAgMTAwIDE2IDggOCAwIDAwMC0xNnptLTEwIDhjMC01LjUyMyA0LjQ3Ny0xMCAxMC0xMHMxMCA0LjQ3NyAxMCAxMC00LjQ3NyAxMC0xMCAxMC0xMC00LjQ3Ny0xMC0xMHoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGQ9Ik03LjI3IDEzLjI0NmEuNzYuNzYgMCAwMS0uNzctLjc1Ljc2Ljc2IDAgMDEuNzctLjc1aDYuNjA0bC0uOTk1LS45N2EuNzM3LjczNyAwIDAxMC0xLjA2Ljc4My43ODMgMCAwMTEuMDg4IDBsMi4zMDggMi4yNWMuMy4yOTIuMy43NjcgMCAxLjA2bC0yLjMwOCAyLjI1YS43ODMuNzgzIDAgMDEtMS4wODggMCAuNzM3LjczNyAwIDAxMC0xLjA2bC45OTUtLjk3SDcuMjY5eiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";